<edu-card class="settings-card">
  <h2 edu-card-title>WhatsApp welcome video</h2>
  <p class="desc">
    The video sent at the top of the WhatsApp welcome message that new students
    and their parents receive. Organizations without their own video use the
    default one.
  </p>

  <div class="video-row">
    <div class="video-label">
      <span class="video-title">
        {{ configured ? 'Custom welcome video set' : 'Using the default welcome video' }}
      </span>
      @if (canManage) {
        <span class="video-hint">MP4 video, up to 16 MB.</span>
      } @else {
        <span class="video-hint">You do not have permission to change this setting.</span>
      }
    </div>

    <div class="video-actions">
      @if (videoUrl && canManage) {
        <button
          type="button"
          class="remove-button"
          [disabled]="isUploading || isLoading || isRemoving"
          (click)="removeVideo()"
        >
          {{ isRemoving ? 'Removing…' : 'Remove' }}
        </button>
      }

      <label class="upload-button" [class.disabled]="!canManage || isUploading || isLoading || isRemoving">
        {{ isUploading ? 'Uploading…' : videoUrl ? 'Replace video' : 'Upload video' }}
        <input
          type="file"
          accept="video/mp4"
          hidden
          [disabled]="!canManage || isUploading || isLoading || isRemoving"
          (change)="onFileSelected($event)"
        />
      </label>
    </div>
  </div>

  <div class="video-frame">
    @if (videoUrl) {
      <video class="video-preview" controls preload="metadata" [src]="videoUrl"></video>
    } @else {
      <div class="video-placeholder">
        <span class="video-placeholder__icon">🎬</span>
        <span class="video-placeholder__text">No video uploaded yet</span>
        <span class="video-placeholder__hint">The default welcome video is sent instead.</span>
      </div>
    }
  </div>

  @if (isUploading) {
    <div class="upload-progress">
      <mat-progress-bar
        [mode]="uploadPhase == 'uploading' ? 'determinate' : 'indeterminate'"
        [value]="uploadProgress"
      ></mat-progress-bar>
      <span class="upload-progress__label">
        @switch (uploadPhase) {
          @case ('reading') { Reading file… }
          @case ('initiating') { Preparing upload… }
          @case ('uploading') { Uploading… {{ uploadProgress }}% }
          @case ('finalizing') { Finishing up… }
        }
      </span>
    </div>
  }

  @if (error) {
    <p class="upload-error">{{ error }}</p>
  }
</edu-card>
